import Flash from './Flash'
export default Flash;
